import { useAuth0 } from '@auth0/auth0-react';
import { getIsFeatureEnabled } from '@core/flagsmith';
import { FilterFilled, FilterOutline } from '@deepup/icons';
import { Divider, IconButton, Stack, Typography } from '@mui/material';
import Popover from '@mui/material/Popover';
import { photosState } from '@photos/components/PhotosInViewport/state';
import { useFlags } from '@flagsmith/flagsmith/react';
import * as React from 'react';
import { useSnapshot } from 'valtio';
import { PhotosCategory } from './PhotosCategory';
import { PhotosClassifications } from './PhotosClassifications';
import { PhotosScanners } from './PhotosScanners';

export const PhotosFilters = () => {
  const { photo_classifications_enabled } = useFlags(['photo_classifications_enabled']);
  const { user } = useAuth0();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const { showPhotos } = useSnapshot(photosState);

  const photoClassificationsEnabled = getIsFeatureEnabled(photo_classifications_enabled, user);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton
        onClick={handleClick}
        disabled={!showPhotos}
        color={open ? 'primary' : 'secondary'}
      >
        {open ? <FilterFilled /> : <FilterOutline />}
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Stack minWidth={200}>
          <Stack p={2}>
            <Typography>Photos Filter</Typography>
          </Stack>
          <Divider />
          <Stack p={2} gap={2}>
            <PhotosCategory />
            <PhotosScanners />
            {photoClassificationsEnabled && <PhotosClassifications />}
          </Stack>
        </Stack>
      </Popover>
    </>
  );
};
